import { MultiSelect as MantineMultiSelect } from "@mantine/core";
import FilterLayout from "./FilterLayout";

interface Props<T extends string> {
  filterName: string;
  values?: T[];
  onChange: (values: T[]) => void;
  data: T[];
}

const MultiSelect = <T extends string = string>({
  filterName,
  onChange,
  values = [],
  data,
}: Props<T>) => {
  return (
    <FilterLayout filterName={filterName}>
      <MantineMultiSelect
        placeholder="Pick values"
        size="xs"
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        onChange={onChange as any} // The generic type ensure that only values of "T" types can be set.
        clearable
        value={values}
        data={data}
      />
    </FilterLayout>
  );
};

export default MultiSelect;
